import InsureRules from './InsureRules';
export default InsureRules;
